import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latestComics = comics
    .filter((c) => c.isNew)
    .sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime())
    .slice(0, 6);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-1">
              <i className="ri-timer-flash-line text-primary-500 mr-2"></i>
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">最近更新的韩漫作品</p>
          </div>
          <Link
            to="/category/ongoing"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            更多连载
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {latestComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.slug}`}
              className="group"
            >
              <div className="relative overflow-hidden rounded-lg mb-2 md:mb-3 aspect-[2/3]">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute top-2 left-2">
                  <span className="inline-block px-2 py-0.5 rounded text-[10px] md:text-xs font-semibold bg-primary-500 text-background-50">
                    新番
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-2 md:p-3">
                  <p className="text-[10px] md:text-xs text-white/80">
                    更新至 {comic.chapters} 话
                  </p>
                </div>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500">更新于 {comic.updateDate}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}